import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  statsCriteriaLoad,
  statsCriteriaLoadFailure,
  statsCriteriaLoadSuccess,
} from "../../actions/stats/stats-criteria.actions";
import { statsCriteriaEditAllLoadSuccess } from "../../actions/stats/stats-crtieria-all-edit.actions";
import { CourseCriteria } from "src/app/shared/interfaces/student-pass-criteria-api";
import { RequestStatus } from "src/app/shared/interfaces/request-status";

export interface StatsCriteriaState {
  criteria: CourseCriteria | null;
  error: HttpErrorResponse | null;
  status: RequestStatus;
}

const initialState: StatsCriteriaState = {
  criteria: null,
  error: null,
  status: "IDLE",
};

export const createStatsCriteriaReducer = createReducer(
  initialState,
  on(
    statsCriteriaLoad,
    (state): StatsCriteriaState => ({
      ...state,
      criteria: null,
      error: null,
      status: "PENDING",
    }),
  ),
  on(
    statsCriteriaLoadSuccess,
    (state, action): StatsCriteriaState => ({
      ...state,
      criteria: action.criteria,
      error: null,
      status: "SUCCESS",
    }),
  ),
  on(
    statsCriteriaEditAllLoadSuccess,
    (state, action): StatsCriteriaState => ({
      ...state,
      criteria: action.criteria,
      error: null,
      status: "SUCCESS",
    }),
  ),
  on(statsCriteriaLoadFailure, (state, { error }) => ({
    ...state,
    error: error,
    status: "FAILED",
  })),
);
